import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { components } from "@/api/schema";

export type Me = components["schemas"]["Me"];

export class UnauthorizedError extends Error {
  constructor() {
    super("unauthorized");
  }
}

async function fetchMe(): Promise<Me> {
  const { data, error, response } = await api.GET("/me");
  if (response.status === 401) throw new UnauthorizedError();
  if (error || !data) throw new Error((error as { message?: string } | undefined)?.message ?? "не удалось загрузить");
  return data;
}

/** Текущий пользователь. 401 — редирект на /login с возвратом. */
export function useMe() {
  return useQuery({
    queryKey: ["me"],
    queryFn: fetchMe,
    retry: (count, err) => !(err instanceof UnauthorizedError) && count < 2,
    staleTime: 60_000,
  });
}
